import React from 'react';
import authRoles from '../../../auth/authRoles';
import SettingsTab from './SettingsTab';

const SettingsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/Settings',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SettingsTab />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default SettingsConfig;
